var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path !== '/swimvirus')?_c('Header'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container mobile-fixed",staticStyle:{"margin-top":"10px"}},[_c('router-view')],1),(_vm.$route.path !== '/swimvirus')?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }